var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_546",
    "data-name": "Group 546",
    transform: "translate(-630 -740)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 64,
    height: 64,
    transform: "translate(630 740)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(-948.949 -702.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9057",
    "data-name": "Path 9057",
    d: "M1622.841,1493.124l-.633-.934c3.7-4.7,3.153-10.034,1.587-14.65l1.011-.817C1626.563,1481.91,1626.939,1487.983,1622.841,1493.124Z",
    transform: "translate(4.639 3.94)",
    fill: "#7bbdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9058",
    "data-name": "Path 9058",
    d: "M1622.688,1492.249l.218.321c3.075-4.122,3.67-9.235,1.767-15.208l-.42.341c1.925,5.85,1.409,10.614-1.565,14.547Zm.2,1.271h-.009a.361.361,0,0,1-.277-.155l-.634-.933a.351.351,0,0,1,.009-.412c3-3.822,3.5-8.509,1.536-14.324a.356.356,0,0,1,.11-.386l1-.815a.336.336,0,0,1,.316-.066.343.343,0,0,1,.24.223c2.212,6.516,1.506,12.3-2.013,16.734a.348.348,0,0,1-.282.133Z",
    transform: "translate(4.596 3.897)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9059",
    "data-name": "Path 9059",
    d: "M1622.058,1495.305a3.6,3.6,0,1,0-2.682-.668,3.609,3.609,0,0,0,2.682.668Z",
    transform: "translate(4.036 5.545)",
    fill: "#7bbdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9060",
    "data-name": "Path 9060",
    d: "M1621.577,1488.521a3.541,3.541,0,0,0-.485.034,3.258,3.258,0,1,0,.951,6.447h0a3.258,3.258,0,0,0-.467-6.482Zm.525,6.828Zm-.534.391a3.985,3.985,0,1,1,.585-.044h0a3.781,3.781,0,0,1-.586.044Z",
    transform: "translate(3.992 5.501)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9061",
    "data-name": "Path 9061",
    d: "M1593.517,1476.157l3.461-2,.247-.081a4.055,4.055,0,0,1,1.686-.084,8.579,8.579,0,0,1,4.232,2.328,15.211,15.211,0,0,1,4.61,9.17,7.02,7.02,0,0,1-.487,3.47,3.9,3.9,0,0,1-.792,1.135l-.2.176-3.46,2c.138-.125.258-.227.387-.367a4.459,4.459,0,0,0,.833-1.518,9.213,9.213,0,0,0-.111-4.953,15.168,15.168,0,0,0-5.531-8.161,6.773,6.773,0,0,0-3.539-1.33,3.9,3.9,0,0,0-1.09.135Z",
    transform: "translate(0.604 3.55)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9062",
    "data-name": "Path 9062",
    d: "M1595.215,1475.649a7.415,7.415,0,0,1,3.422,1.376,15.529,15.529,0,0,1,5.669,8.359,9.57,9.57,0,0,1,.1,5.152,4.42,4.42,0,0,1-.235.618l1.972-1.141.137-.136a3.381,3.381,0,0,0,.715-1.022,6.845,6.845,0,0,0,.456-3.293,15,15,0,0,0-4.5-8.94,8.4,8.4,0,0,0-4.056-2.234,3.564,3.564,0,0,0-1.526.072l-.24.078-1.913,1.111Zm7.645,17.014a.351.351,0,0,1-.227-.612,3.754,3.754,0,0,0,.346-.341,3.866,3.866,0,0,0,.763-1.389,8.975,8.975,0,0,0-.107-4.754,14.854,14.854,0,0,0-5.4-7.964,6.417,6.417,0,0,0-3.35-1.268,3.434,3.434,0,0,0-.982.123l-.24.078a.34.34,0,0,1-.424-.188.344.344,0,0,1,.149-.448l3.448-2,.317-.114a4.43,4.43,0,0,1,1.844-.095,9.007,9.007,0,0,1,4.422,2.418,15.414,15.414,0,0,1,4.719,9.394,7.364,7.364,0,0,1-.513,3.647,4.26,4.26,0,0,1-.865,1.242l-.208.186-3.519,2.035a.342.342,0,0,1-.173.05Z",
    transform: "translate(0.561 3.507)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9063",
    "data-name": "Path 9063",
    d: "M1598.017,1491.854a14.594,14.594,0,0,1-6.6-11.443c0-4.21,2.955-5.919,6.6-3.815a14.625,14.625,0,0,1,6.614,11.448C1604.631,1492.257,1601.664,1493.961,1598.017,1491.854Z",
    transform: "translate(0.308 3.796)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9064",
    "data-name": "Path 9064",
    d: "M1598.241,1491.6c1.652.954,3.179,1.118,4.321.46s1.753-2.065,1.753-3.969a14.238,14.238,0,0,0-6.433-11.143c-1.646-.954-3.182-1.118-4.312-.463s-1.767,2.068-1.767,3.974a14.237,14.237,0,0,0,6.438,11.142Zm2.773,1.559a6.363,6.363,0,0,1-3.132-.952h0a15.015,15.015,0,0,1-6.781-11.749c0-2.166.753-3.8,2.109-4.581s3.157-.622,5.031.464a15.019,15.019,0,0,1,6.78,11.749c0,2.167-.745,3.792-2.113,4.58a3.712,3.712,0,0,1-1.894.486Z",
    transform: "translate(0.264 3.752)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9065",
    "data-name": "Path 9065",
    d: "M1614.2,1463.508l3.727-2.149.269-.09a4.363,4.363,0,0,1,1.815-.089,9.257,9.257,0,0,1,4.559,2.506,16.378,16.378,0,0,1,4.968,9.878,7.631,7.631,0,0,1-.526,3.736,4.286,4.286,0,0,1-.852,1.225l-.21.188-3.725,2.152a4.329,4.329,0,0,0,.406-.4,4.471,4.471,0,0,0,.89-1.632,9.857,9.857,0,0,0-.107-5.334,16.332,16.332,0,0,0-5.959-8.8,7.283,7.283,0,0,0-3.808-1.432,4.153,4.153,0,0,0-1.181.147Z",
    transform: "translate(3.514 1.747)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9066",
    "data-name": "Path 9066",
    d: "M1615.942,1462.978a7.831,7.831,0,0,1,3.756,1.485,16.7,16.7,0,0,1,6.1,8.99,10.318,10.318,0,0,1,.107,5.531,5.18,5.18,0,0,1-.3.745l2.208-1.276.15-.146a4.036,4.036,0,0,0,.775-1.109,7.125,7.125,0,0,0,.484-3.56,16.054,16.054,0,0,0-4.848-9.65,9.02,9.02,0,0,0-4.38-2.417,4.021,4.021,0,0,0-1.656.08l-.26.084-2.139,1.243Zm8.329,18.283a.357.357,0,0,1-.287-.147.352.352,0,0,1,.048-.469,4.977,4.977,0,0,0,.386-.365,4.479,4.479,0,0,0,.825-1.509,9.759,9.759,0,0,0-.12-5.138,16.018,16.018,0,0,0-5.819-8.595,6.9,6.9,0,0,0-3.618-1.369,3.754,3.754,0,0,0-1.073.129l-.258.086a.343.343,0,0,1-.424-.192.348.348,0,0,1,.138-.448l3.727-2.148.339-.12a4.684,4.684,0,0,1,1.971-.1,9.708,9.708,0,0,1,4.75,2.6,16.65,16.65,0,0,1,5.076,10.1,7.979,7.979,0,0,1-.556,3.915,4.4,4.4,0,0,1-.93,1.329l-.217.2-3.781,2.195a.387.387,0,0,1-.177.041Z",
    transform: "translate(3.47 1.703)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9067",
    "data-name": "Path 9067",
    d: "M1619.054,1480.42a15.72,15.72,0,0,1-7.119-12.327c0-4.54,3.182-6.381,7.119-4.112a15.747,15.747,0,0,1,7.119,12.331C1626.173,1480.853,1622.98,1482.689,1619.054,1480.42Z",
    transform: "translate(3.195 2.012)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9068",
    "data-name": "Path 9068",
    d: "M1615.914,1463.4a3.3,3.3,0,0,0-1.677.427c-1.229.712-1.913,2.243-1.913,4.307a15.366,15.366,0,0,0,6.94,12.022h0c1.8,1.031,3.461,1.21,4.69.5s1.9-2.239,1.9-4.3a15.359,15.359,0,0,0-6.939-12.026,6.141,6.141,0,0,0-3-.926Zm6.365,18.387a6.838,6.838,0,0,1-3.361-1.024,16.115,16.115,0,0,1-7.285-12.629c0-2.328.8-4.073,2.259-4.915s3.361-.665,5.374.5a16.142,16.142,0,0,1,7.3,12.635c0,2.325-.8,4.07-2.26,4.909a4,4,0,0,1-2.027.527Z",
    transform: "translate(3.152 1.968)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9069",
    "data-name": "Path 9069",
    d: "M1591.8,1476.443l3.729-2.15.266-.089a4.365,4.365,0,0,1,1.815-.089,9.2,9.2,0,0,1,4.559,2.507,16.361,16.361,0,0,1,4.971,9.877,7.633,7.633,0,0,1-.527,3.738,4.265,4.265,0,0,1-.853,1.226l-.208.187-3.729,2.149a3.566,3.566,0,0,0,.406-.395,4.653,4.653,0,0,0,.9-1.635,10.037,10.037,0,0,0-.106-5.335,16.4,16.4,0,0,0-5.972-8.792,7.27,7.27,0,0,0-3.806-1.434,4.127,4.127,0,0,0-1.169.146Z",
    transform: "translate(0.362 3.566)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9070",
    "data-name": "Path 9070",
    d: "M1593.536,1475.915a7.893,7.893,0,0,1,3.765,1.483,16.8,16.8,0,0,1,6.1,8.988,10.52,10.52,0,0,1,.111,5.536,6.132,6.132,0,0,1-.309.74l2.213-1.273.146-.149a3.665,3.665,0,0,0,.773-1.109,7.251,7.251,0,0,0,.5-3.559,16.12,16.12,0,0,0-4.856-9.65,9.069,9.069,0,0,0-4.372-2.415,3.976,3.976,0,0,0-1.668.079l-.257.087-2.14,1.242Zm8.326,18.28a.352.352,0,0,1-.286-.146.36.36,0,0,1,.05-.467,3.629,3.629,0,0,0,.386-.367,4.262,4.262,0,0,0,.821-1.509,9.657,9.657,0,0,0-.116-5.137,16.033,16.033,0,0,0-5.822-8.595,6.891,6.891,0,0,0-3.618-1.368,3.727,3.727,0,0,0-1.07.13l-.248.084a.351.351,0,0,1-.289-.636l3.719-2.152.335-.116a4.674,4.674,0,0,1,1.975-.1,9.664,9.664,0,0,1,4.749,2.6,16.565,16.565,0,0,1,5.076,10.1,7.893,7.893,0,0,1-.555,3.915,4.358,4.358,0,0,1-.923,1.329l-.227.2-3.778,2.192a.361.361,0,0,1-.179.038Z",
    transform: "translate(0.319 3.523)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9071",
    "data-name": "Path 9071",
    d: "M1596.645,1493.355a15.742,15.742,0,0,1-7.119-12.327c0-4.54,3.193-6.384,7.119-4.113a15.754,15.754,0,0,1,7.12,12.33C1603.765,1493.789,1600.572,1495.623,1596.645,1493.355Z",
    transform: "translate(0.042 3.831)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9072",
    "data-name": "Path 9072",
    d: "M1593.517,1476.337a3.3,3.3,0,0,0-1.685.429c-1.232.71-1.9,2.24-1.9,4.306a15.357,15.357,0,0,0,6.939,12.022c1.784,1.031,3.453,1.21,4.68.5s1.913-2.239,1.913-4.3a15.385,15.385,0,0,0-6.948-12.025,6.09,6.09,0,0,0-3-.927Zm6.354,18.388a6.819,6.819,0,0,1-3.359-1.024,16.143,16.143,0,0,1-7.289-12.629c0-2.326.8-4.071,2.262-4.916s3.367-.664,5.382.5a16.159,16.159,0,0,1,7.3,12.631c0,2.329-.8,4.071-2.263,4.911a4.006,4.006,0,0,1-2.033.527Z",
    transform: "translate(0 3.787)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9073",
    "data-name": "Path 9073",
    d: "M1615.811,1456.6a7.488,7.488,0,0,0-1.625-3.147h0c2.626.589,4.422,2.944,4.71,6.668.021.342.039,3.445.039,3.813a13.7,13.7,0,0,1-.07,1.44v.033l-.128-.078a6.794,6.794,0,0,0-2.8-.953h0a24.973,24.973,0,0,0-.126-7.776Z",
    transform: "translate(3.511 0.667)",
    fill: "#7bbdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9074",
    "data-name": "Path 9074",
    d: "M1616.4,1464.111a7.123,7.123,0,0,1,2.2.758c.021-.293.021-.579.021-.9,0-.44-.009-3.471-.041-3.787-.219-2.959-1.435-5.08-3.368-5.992a9.592,9.592,0,0,1,.981,2.349v.017a26.442,26.442,0,0,1,.208,7.55Zm2.478,1.679a.309.309,0,0,1-.149-.042l-.128-.078a6.473,6.473,0,0,0-2.645-.908.339.339,0,0,1-.251-.14.368.368,0,0,1-.059-.284,24.479,24.479,0,0,0-.138-7.613,6.874,6.874,0,0,0-1.537-2.991.343.343,0,0,1-.068-.382.352.352,0,0,1,.326-.212c2.955.654,4.77,3.2,5.055,6.993.031.379.039,3.622.039,3.841a13.869,13.869,0,0,1-.068,1.473.368.368,0,0,1-.188.3.409.409,0,0,1-.188.043Z",
    transform: "translate(3.467 0.624)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9075",
    "data-name": "Path 9075",
    d: "M1609.98,1449.861c2.649-.982,4.968-1.288,7.547.063l2.776,1.6a7.687,7.687,0,0,0-5.573-.675c-5.771,1.434-10.113,6.132-13.185,10.988a29.5,29.5,0,0,0-4.394,12.555c-.03,1.817-.138,3.729-.03,5.558a6.76,6.76,0,0,0-2.776-.953c-.03-1.808-.03-3.562-.018-5.382a28.163,28.163,0,0,1,3.509-11.781C1600.68,1456.762,1604.539,1452.2,1609.98,1449.861Z",
    transform: "translate(0.717 0.044)",
    fill: "#7bbdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9076",
    "data-name": "Path 9076",
    d: "M1594.736,1478.729a6.85,6.85,0,0,1,2.053.666c-.039-1.141-.009-2.306.021-3.437.018-.513.027-1.026.039-1.526a29.96,29.96,0,0,1,4.431-12.729c3.907-6.159,8.408-9.906,13.4-11.15a10.447,10.447,0,0,1,2.836-.209l-.129-.072c-2.669-1.4-5.057-.849-7.239-.042-4.679,2.018-8.7,6-11.965,11.82a27.819,27.819,0,0,0-3.47,11.631c-.009,1.7,0,3.354.018,5.047Zm2.43,1.616a.359.359,0,0,1-.179-.048,6.436,6.436,0,0,0-2.627-.906.358.358,0,0,1-.325-.346c-.022-1.808-.031-3.566-.022-5.385a28.552,28.552,0,0,1,3.559-11.945c3.341-5.975,7.487-10.054,12.317-12.133l.017-.007c2.332-.866,4.9-1.455,7.833.081l2.786,1.607a.362.362,0,0,1,.128.476.35.35,0,0,1-.467.144,7.371,7.371,0,0,0-5.352-.646c-4.787,1.194-9.15,4.842-12.949,10.833a29.181,29.181,0,0,0-4.343,12.4c0,.478-.02.989-.03,1.506-.039,1.324-.078,2.693,0,4a.349.349,0,0,1-.159.319.417.417,0,0,1-.188.05Z",
    transform: "translate(0.673)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9077",
    "data-name": "Path 9077",
    d: "M1618.153,1480.009a14.252,14.252,0,0,1-6.446-11.169c0-4.111,2.887-5.782,6.446-3.723a14.265,14.265,0,0,1,6.453,11.17C1624.606,1480.4,1621.713,1482.064,1618.153,1480.009Z",
    transform: "translate(3.162 2.184)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9078",
    "data-name": "Path 9078",
    d: "M1615.322,1464.629a2.959,2.959,0,0,0-1.506.382c-1.1.64-1.715,2.014-1.715,3.872a13.892,13.892,0,0,0,6.276,10.867c1.6.926,3.1,1.088,4.214.451s1.7-2.011,1.7-3.87a13.889,13.889,0,0,0-6.276-10.868,5.5,5.5,0,0,0-2.7-.834Zm5.759,16.66a6.25,6.25,0,0,1-3.064-.932,14.667,14.667,0,0,1-6.623-11.474c0-2.118.736-3.71,2.074-4.479s3.074-.609,4.908.452a14.677,14.677,0,0,1,6.622,11.475c0,2.119-.735,3.709-2.062,4.478a3.68,3.68,0,0,1-1.855.48Z",
    transform: "translate(3.118 2.14)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9079",
    "data-name": "Path 9079",
    d: "M1617.945,1477.787a10.513,10.513,0,0,1-4.756-8.238c0-3.033,2.13-4.265,4.756-2.748a10.514,10.514,0,0,1,4.758,8.24C1622.7,1478.078,1620.573,1479.3,1617.945,1477.787Z",
    transform: "translate(3.371 2.454)",
    fill: "#7bbdfd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9080",
    "data-name": "Path 9080",
    d: "M1618.167,1477.527a2.56,2.56,0,0,0,4.231-2.442,10.155,10.155,0,0,0-4.59-7.938,2.557,2.557,0,0,0-4.223,2.446,10.14,10.14,0,0,0,4.582,7.934Zm1.952,1.3a4.7,4.7,0,0,1-2.311-.7h0a10.915,10.915,0,0,1-4.924-8.541,3.24,3.24,0,0,1,5.283-3.051,10.916,10.916,0,0,1,4.924,8.543,3.671,3.671,0,0,1-1.565,3.383,2.764,2.764,0,0,1-1.407.371Z",
    transform: "translate(3.328 2.41)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9081",
    "data-name": "Path 9081",
    d: "M1610.345,1452.281c7.513-4.336,13.6-.818,13.6,7.852l-.009,3.323a8.68,8.68,0,0,1-.051.887l-2.568,1.485a14.339,14.339,0,0,0,.07-1.473c0-.368-.018-3.471-.039-3.813-.487-6.255-5.224-8.644-11-5.309-5.872,3.392-10.669,11.449-11.027,18.328-.009.269-.018,3.278-.018,3.542a12.227,12.227,0,0,0,.059,1.249l-.192.137-2.387,1.265c-.03-.379-.039-.771-.039-1.173,0-.427.021-3.6.048-4.039C1597.345,1466.142,1603.206,1456.4,1610.345,1452.281Z",
    transform: "translate(1.058 0.242)",
    fill: "#c8e6fe",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9082",
    "data-name": "Path 9082",
    d: "M1610.564,1452.627c-6.948,4.014-12.829,13.67-13.385,21.984-.027.412-.048,3.508-.048,4.015,0,.2.009.4.021.6l1.883-.995c-.031-.349-.039-.712-.039-1.085,0-.206,0-3.276.017-3.559.359-7.021,5.276-15.193,11.2-18.615,2.974-1.713,5.8-2.024,7.979-.876,2.053,1.085,3.313,3.38,3.55,6.462.031.379.039,3.622.039,3.841,0,.294,0,.568-.017.835l1.844-1.06c.009-.24.031-.44.031-.679l.008-3.319c0-4.063-1.36-7.081-3.815-8.5s-5.741-1.079-9.262.953h0Zm-13.74,27.52a.292.292,0,0,1-.167-.044.321.321,0,0,1-.179-.283c-.03-.386-.039-.784-.039-1.194,0-.375.009-3.609.039-4.063.566-8.524,6.6-18.427,13.732-22.543h0c3.747-2.164,7.285-2.5,9.973-.954s4.153,4.785,4.153,9.11v3.323c-.008.316-.03.57-.047.887a.413.413,0,0,1-.18.3l-2.579,1.485a.326.326,0,0,1-.356-.009.317.317,0,0,1-.157-.327c.039-.494.059-.924.059-1.437,0-.44-.009-3.471-.041-3.787-.208-2.832-1.337-4.925-3.18-5.894-1.946-1.031-4.542-.727-7.29.863-5.74,3.311-10.5,11.237-10.844,18.043-.022.25-.022,3.187-.022,3.522a11.416,11.416,0,0,0,.051,1.219.346.346,0,0,1-.149.316l-.188.135-2.417,1.291a.39.39,0,0,1-.173.042Z",
    transform: "translate(1.015 0.198)",
    fill: "#2874e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9083",
    "data-name": "Path 9083",
    d: "M1596.078,1490.717a11,11,0,0,1-4.987-8.627c0-3.178,2.232-4.469,4.987-2.878a11.022,11.022,0,0,1,4.98,8.63C1601.058,1491.021,1598.825,1492.307,1596.078,1490.717Z",
    transform: "translate(0.263 4.195)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9084",
    "data-name": "Path 9084",
    d: "M1596.292,1490.459a2.7,2.7,0,0,0,4.459-2.573,10.665,10.665,0,0,0-4.809-8.33,2.695,2.695,0,0,0-4.45,2.578,10.638,10.638,0,0,0,4.8,8.326Zm2.05,1.338a4.87,4.87,0,0,1-2.4-.732h0a11.4,11.4,0,0,1-5.155-8.931,3.378,3.378,0,0,1,5.5-3.184,11.426,11.426,0,0,1,5.164,8.936,3.839,3.839,0,0,1-1.635,3.528,2.945,2.945,0,0,1-1.474.386Z",
    transform: "translate(0.22 4.151)",
    fill: "#2874e7",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.a72da301fe80baa4310b855e3a578e71.svg";
export { ForwardRef as ReactComponent };